import React, { useState, useRef, useEffect } from "react";

export const mediaContext = React.createContext();

const MediaPlayerContext = (props) => {
    const audioRef = useRef();
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlaying = () => {
        return setIsPlaying(!isPlaying);
    };

    useEffect(() => {
        isPlaying ? audioRef.current.play() : audioRef.current.pause();
    }, [audioRef, isPlaying]);

    useEffect(() => {
        audioRef.current.volume = 0.5;
    }, [audioRef]);

    const contextValue = {
        isPlaying,
        setIsPlaying,
        handlePlaying,
        audioRef,
    };

    return (
        <mediaContext.Provider value={contextValue}>
            {props.children}
        </mediaContext.Provider>
    );
};

export default MediaPlayerContext;
